module.exports = require("./sd-Deva.d.ts");